/**
 * API Configuration
 * This utility handles the backend URL configuration to support custom domains
 */

// Get the backend URL - use same origin if accessing from custom domain
export const getBackendUrl = () => {
  // If we're on a custom domain (not emergent preview/host), use same origin
  const hostname = window.location.hostname;
  
  // List of known Emergent domains where we should use the env variable
  const emergentDomains = ['emergentagent.com', 'emergent.host', 'localhost'];
  
  const isEmergentDomain = emergentDomains.some(domain => hostname.includes(domain));
  
  if (isEmergentDomain) {
    // Use the configured backend URL for Emergent domains
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  
  // For custom domains (like customer.fleety.co.in), use same origin
  return window.location.origin;
};

export const API_URL = getBackendUrl();
export const API = `${API_URL}/api`;

export default { getBackendUrl, API_URL, API };
